<div class="transfer-container" [class.minimized]="transferView.isMinimized">
    <div class="transfer-title">
        <div class="sheetheader" (click)="onMinimizeToggle()">
            <div class="draghandle"></div>
        </div>
        <div class="header">
            <div class="head-line">
                <span>File Transfers</span>
                <span>({{filetransfersText}})</span>
            </div>
            <div class="adornment">
                <sync-icon-button [iconName]="transferView.isMinimized ? 'chevron-up' : 'chevron-down'" size="small"
                    [onClick]="onMinimizeToggle" [matTooltip]="transferView.isMinimized ? 'Maximize' : 'Minimize'"></sync-icon-button>
            </div>
            <div class="adornment" *ngIf="!transferView.upload.isProcessing && !transferView.download.isProcessing && !foldertransferView.isScanning && !foldertransferView.isProcessing && !downloadZipService.isProcessing()">
                <sync-icon-button iconName="close" size="small" [onClick]="onCloseTransfer" [matTooltip]="'Close'"></sync-icon-button>
            </div>

        </div>
        <div class="total-progress">
            <ng-container *ngIf="transferView.upload.isProcessing || transferView.download.isProcessing || foldertransferView.isScanning || foldertransferView.isProcessing || downloadZipService.isProcessing()">
                <div class="status-icon">
                    <sync-icon name="upload-inprogress"></sync-icon>
                </div>
                <div class="status-text">
                    <span *ngIf="!estimatedTime">Transfers in progress</span>
                    <span *ngIf="estimatedTime">Estimated time: {{estimatedTime}}</span>
                </div>
            </ng-container>

            <ng-container *ngIf="!transferView.upload.isProcessing && !transferView.download.isProcessing && !foldertransferView.isScanning && !foldertransferView.isProcessing && !downloadZipService.isProcessing()">
                <ng-container *ngIf="hasError">
                    <div class="status-icon">
                        <sync-icon name="error"></sync-icon>
                    </div>
                    <div class="status-text">
                        <span>Issue with one or more items</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="!hasError">
                    <div class="status-icon">
                        <sync-icon name="checkmark"></sync-icon>
                    </div>
                    <div class="status-text">
                        <span>All transfers complete</span>
                    </div>
                </ng-container>
            </ng-container>


        </div>
        <ng-container *ngIf="!transferView.isMinimized">
            <div class="divider"></div>
            <div class="filter-container" *ngIf="showFilter">
                <sync-chips size="large" label="All transfers" [onClick]="onAllFilter"
                    [active]="filterBy === 'all'"></sync-chips>
                <sync-chips size="large" label="Uploads" [onClick]="onUploadFilter"
                    [active]="filterBy === 'upload'"></sync-chips>
                <sync-chips size="large" label="Downloads" [onClick]="onDownloadFilter"
                    [active]="filterBy === 'download'"></sync-chips>
            </div>
        </ng-container>
    </div>
    <div class="transfer-content" [class.hide]="transferView.isMinimized">
        <div class="empty-message" *ngIf="queueLength === 0">
            No transfers in progress.
        </div>
        <div class="empty-message" *ngIf="(!transferView.upload.queue.length && !foldertransferView.rootItems.length && filterBy === 'upload') || (filterBy === 'download' && !transferView.download.queue.length)">No {{filterBy}}s in progress.</div>
        <div class="list-wrapper" (mouseleave)="transferIndex = -1; foldertransferIndex = -1; downloadtransferIndex = -1">
            <ng-container *ngIf="filterBy === 'all' || filterBy === 'download'">
                <ng-container *ngFor="let item of transferView.download.queue; let i = index">
                    <div *ngIf="item.status !== 1002">
                        <div class="transfer-item-wrapper"
                            [class.item-focused]="downloadtransferIndex === i"
                            (mouseenter)="downloadtransferIndex = i;transferIndex = -1; foldertransferIndex = -1;"
                            (click)="transferIndex = -1; foldertransferIndex = -1;(downloadtransferIndex === i ? downloadtransferIndex = -1 : downloadtransferIndex = i)">
                            <div class="adornment">
                                <sync-icon [name]="item.filedata.icon"></sync-icon>
                            </div>
                            <div class="item-detail">
                                <div class="file-name ellipsis" [class.file-error]="item.status > 1000" [matTooltip]="item.filename">{{item.filename}}
                                </div>
                                <div class="file-progress"
                                    *ngIf="(item.status >= 10 && item.status < 20) || item.status === 0">
                                    {{'Downloading ' + utilService.bytesToSize(item.bytes_sent) + ' of ' +
                                    utilService.bytesToSize(item.filesize)}}
                                </div>
                                <div class="file-progress" *ngIf="item.status === 1 && item.type === 10">
                                Ready to download
                                </div>
                                <div class="file-progress file-error" *ngIf="item.status > 1000"
                                    [innerHTML]="(item.status | translateTransferItem:true)"></div>
                            </div>
                            <div class="transfer-status">
                                <div class="adornment" *ngIf="item.status === 1 && item.type === 10">
                                    <app-save-file *ngIf="item?.renderFile?.dl_ready" [saveFile]="item"
                                        [autodownload]="1"></app-save-file>
                                    <sync-icon-button iconName="download" *ngIf="!item?.renderFile?.dl_ready"
                                        (click)="downloadCompatible(item)" [matTooltip]="'Download'">
                                    </sync-icon-button>
                                </div>
                                <div class="adornment" *ngIf="(item.status >= 10 && item.status < 20) || item.status === 0">
                                    <div class="progress" *ngIf="downloadtransferIndex !== i">
                                        <round-progress [current]="item.progress_percent" [max]="100" [responsive]="true"
                                            [rounded]="true" [radius]="24" [stroke]="7" color="#007BAA"
                                            background="#D9D9D9"></round-progress>
                                    </div>

                                    <sync-icon-button iconName="close" *ngIf="downloadtransferIndex === i"
                                        (click)="cancelDownload(item)" [matTooltip]="'Cancel'"></sync-icon-button>
                                </div>
                                <div class="adornment" *ngIf="item.status > 1000">
                                    <sync-icon name="error" *ngIf="downloadtransferIndex !== i">
                                    </sync-icon>
                                    
                                    <sync-icon-button iconName="refresh" *ngIf="downloadtransferIndex === i"
                                        (click)="downloadCompatible(item)" [matTooltip]="'Retry'">
                                    </sync-icon-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Download as zip handling for publink -->
                <ng-container *ngFor="let item of zipDownloadQueue; let i = index">
                    <div class="transfer-item-wrapper"
                            [class.item-focused]="downloadtransferIndex === i"
                            (mouseenter)="downloadtransferIndex = i;transferIndex = -1; foldertransferIndex = -1;"
                            (click)="transferIndex = -1; foldertransferIndex = -1;(downloadtransferIndex === i ? downloadtransferIndex = -1 : downloadtransferIndex = i)">
                            <div class="adornment">
                                <sync-icon name="file-type-archive"></sync-icon>
                            </div>
                            <div class="item-detail">
                                <div class="file-name ellipsis" [class.file-error]="item.errcode" [matTooltip]="item.name">
                                    {{item.name}}
                                </div>
                                <div class="file-progress"
                                    *ngIf="!item.errcode && !item.dlReady">
                                    Preparing download
                                </div>
                                <div class="file-progress" *ngIf="item.dlReady">
                                    Ready to download
                                </div>
                                <div class="file-progress file-error" *ngIf="item.errcode">
                                    {{item.errcode?.msg}}
                                </div>
                            </div>
                            <div class="transfer-status">
                                <div class="adornment" *ngIf="item.dlReady && item.zipUrl">
                                    <a [href]="item.zipUrl" [download]="item.name">
                                        <sync-icon-button iconName="download">
                                        </sync-icon-button>
                                    </a>
                                </div>
                                <div class="adornment" *ngIf="!item.errcode && !item.dlReady">
                                    <div class="progress">
                                        <sync-icon name="upload-inprogress"></sync-icon>
                                    </div>
                                </div>
                                <div class="adornment" *ngIf="item.errcode">
                                    <sync-icon name="error">
                                    </sync-icon>
                                </div>
                            </div>
                        </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="filterBy === 'all' || filterBy === 'upload'">
                <!-- Files upload transfer view -->
                <ng-container *ngFor="let item of transferView.upload.queue; let i = index">
                    <div class="transfer-item-wrapper" [class.item-focused]="transferIndex === i" *ngIf="item.status !== 1001"
                        (mouseenter)="transferIndex = i;foldertransferIndex = -1; downloadtransferIndex = -1"
                        (click)="foldertransferIndex = -1; downloadtransferIndex = -1; (transferIndex === i ? transferIndex = -1 : transferIndex = i)">
                        <div class="adornment">
                            <sync-icon [name]="item!.filedata!.icon"></sync-icon>
                        </div>
                        <div class="item-detail">
                            <div class="file-name ellipsis" [class.file-error]="item.status > 1000" [matTooltip]="item.filename">{{item.filename}}
                            </div>
                            <div class="file-progress" *ngIf="(item.status >= 10 && item.status < 20) || item.status === 0">
                                {{'Uploading ' + utilService.bytesToSize(item!.progress_bytes) + ' of ' +
                                utilService.bytesToSize(item!.filesize)}}
                            </div>
                            <div class="file-progress" *ngIf="item.status === 1">
                                Upload complete
                            </div>
                            <div class="file-progress file-error" *ngIf="item.status > 1000"
                                [innerHTML]="(item.status | translateTransferItem:true)"></div>
                        </div>
                        <div class="transfer-status">
                            <div class="adornment" *ngIf="item.status === 1 && transferIndex !== i">
                                <sync-icon name="checkmark"></sync-icon>
                            </div>
                            <ng-container *ngIf="item.status === 1 && transferIndex === i">
                                <div class="adornment-success">
                                    <sync-icon-button iconName="folder-open" (click)="handleOpenFolder(item)"
                                        [tooltip]="'Go to folder'"></sync-icon-button>
                                </div>
                                <div class="adornment-success">
                                    <sync-icon-button iconName="preview" (click)="previewItem(item)"
                                        [matTooltip]="'Go to file'"></sync-icon-button>
                                </div>
                            </ng-container>
                            <div class="adornment" *ngIf="(item.status >= 10 && item.status < 20) || item.status === 0">
                                <div class="progress" *ngIf="transferIndex !== i">
                                    <round-progress [current]="item!.progress_percent" [max]="100" [responsive]="true"
                                        [rounded]="true" [radius]="24" [stroke]="7" color="#007BAA"
                                        background="#D9D9D9"></round-progress>
                                </div>
            
                                <sync-icon-button iconName="close" *ngIf="transferIndex === i"
                                    (click)="cancelUpload(item)" [matTooltip]="'Cancel'"></sync-icon-button>
                            </div>
                            <div class="adornment" *ngIf="item.status > 1000">
                                <sync-icon name="error" *ngIf="transferIndex !== i">
                                </sync-icon>
                                <sync-icon-button iconName="refresh" *ngIf="shouldShowRetryButton(item, i)"
                                    (click)="retryUpload(item)" [matTooltip]="'Retry'">
                                </sync-icon-button>
                                <sync-icon-button iconName="close" *ngIf="transferIndex === i && item!.retryCount >= 3"
                                    (click)="cancelUpload(item)" [matTooltip]="'Remove'"></sync-icon-button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            
                <!-- Folder upload transfer view -->
                <ng-container *ngFor="let item of foldertransferView.rootItems; let i = index">
                    <div class="transfer-item-wrapper" [class.item-focused]="foldertransferIndex === i" *ngIf="item.status !== 1001"
                        (mouseenter)="foldertransferIndex = i;transferIndex = -1; downloadtransferIndex = -1;"
                        (click)="transferIndex = -1; downloadtransferIndex = -1; (foldertransferIndex === i ? foldertransferIndex = -1 : foldertransferIndex = i)">
                        <div class="adornment">
                            <sync-icon name="folder"></sync-icon>
                        </div>
                        <div class="item-detail">
                            <div class="file-name ellipsis" [class.file-error]="item.status > 1000" [matTooltip]="item.name">{{item.name}}
                            </div>
                            <div class="file-progress" *ngIf="item.status === 11 || item.status === 0">
                                {{'Uploading ' + (item.completedFiles + item.errorFiles) + ' of ' + item.totalFiles}}
                            </div>
                            <div class="file-progress" *ngIf="item.status === 1">
                                Upload complete
                            </div>
                            <div class="file-progress file-error" *ngIf="item.status > 1000">
                                Upload complete. {{item.errorFiles}} item(s) failed.
                            </div>
                        </div>
                        <div class="transfer-status">
                            <div class="adornment" *ngIf="item.status === 1 && foldertransferIndex !== i">
                                <sync-icon name="checkmark"></sync-icon>
                            </div>
                            <ng-container *ngIf="item.status === 1 && foldertransferIndex === i">
                                <div class="adornment-success">
                                    <sync-icon-button iconName="folder-open" (click)="handlePreviewFolder(item)"
                                        [tooltip]="'Go to location'"></sync-icon-button>
                                </div>
                            </ng-container>
                            <div class="adornment" *ngIf="item.status === 11 || item.status === 0">
                                <div class="progress" *ngIf="foldertransferIndex !== i || item.status === 11 || !foldertransferView.isProcessing">
                                    <round-progress [current]="item!.completedFiles + item!.errorFiles" [max]="item!.totalFiles"
                                        [responsive]="true" [rounded]="true" [radius]="24" [stroke]="7" color="#007BAA"
                                        background="#D9D9D9"></round-progress>
                                </div>
                                        <sync-icon-button iconName="close" *ngIf="foldertransferIndex === i && item.status === 0 && foldertransferView.isProcessing"
                                    (click)="cancelFolderUpload(item)" [matTooltip]="'Cancel'"></sync-icon-button>
                            </div>
                            <ng-container *ngIf="item.status > 1000">
                                <div class="adornment" *ngIf="item!.completedFiles > 0 && foldertransferIndex === i">
                                    <sync-icon-button iconName="folder-open" (click)="handlePreviewFolder(item)"
                                        [tooltip]="'Go to location'"></sync-icon-button>
                                </div>
                                <div class="adornment">
                                    <sync-icon name="error">
                                    </sync-icon>
                                    <!-- Todo in https://syncdev.atlassian.net/browse/UX-848 -->
                                    <!-- <sync-icon-button iconName="refresh" *ngIf="foldertransferIndex === i && item!.retryCount < 3"
                                        (click)="retryFolderUpload(item)">
                                    </sync-icon-button>
                                    <sync-icon-button iconName="close" *ngIf="foldertransferIndex === i && item!.retryCount >= 3"
                                        (click)="cancelUpload(item)"></sync-icon-button> -->
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>